import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller } from 'react-hook-form';
import { TextButton } from 'seagull';
import OTPField from '~/pages/unAuthorizedPages/LoginScreen/Steps/OTPField';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
import styles from './ChangeEmailAddress.module.scss';
const OTPInputSection = (param)=>{
    let { isLoading, control, resendCode } = param;
    const errorMessage = 'Code is invalid. Please try again.';
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.sixDigitCodeInput,
        "data-testid": "one-time-password-section",
        children: [
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "otp",
                rules: {
                    required: errorMessage,
                    minLength: {
                        value: 6,
                        message: errorMessage
                    }
                },
                render: (renderProps)=>/*#__PURE__*/ _jsx(OTPField, _object_spread_props(_object_spread({}, connectControllerToTextField(renderProps), renderProps.field), {
                        testId: "one-time-password",
                        autoFocus: true,
                        width: 360,
                        isLoading: isLoading
                    }))
            }),
            /*#__PURE__*/ _jsx(TextButton, {
                type: "button",
                testId: "resend-code-button",
                onClick: resendCode,
                children: "Resend code"
            })
        ]
    });
};
export default OTPInputSection;
